import { useCallback, useEffect, useMemo, useState } from "react";
import CustomersService from "../../../../../../../../../services/customers";
import { IPrimaryData } from "../../../types/PrimaryData";

export const useFetchPrimaryData = (
  primaryData: IPrimaryData | undefined,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [data, setData] = useState<any[]>([]);

  const formattedData = useMemo(() => {
    const result: any[] = [];

    if (!primaryData) return result;

    for (const item of data) {
      const { customerCompanyData, customerIndividualData, typeId } = item;

      if (item.primaryEmail) {
        result.push({
          id: item.id,
          number: item.number,
          email: item.primaryEmail,
          value: item.primaryEmail,
          type: "Primary email",
          default: true,
          name:
            typeId === 2
              ? customerCompanyData.companyName || ""
              : `${customerIndividualData.name1 || ""} ${
                  customerIndividualData.name2 || ""
                } ${customerIndividualData.name3 || ""}`,
          role: primaryData.buyerId === item.id ? 1 : 2
        });
      }

      if (item.alternativeEmail && item.alternativeEmail !== item.primaryEmail) {
        result.push({
          id: item.id,
          number: item.number,
          email: item.alternativeEmail,
          value: item.alternativeEmail,
          type: "Alternate email",
          default: true,
          name:
            typeId === 2
              ? customerCompanyData.companyName || ""
              : `${customerIndividualData.name1 || ""} ${
                  customerIndividualData.name2 || ""
                } ${customerIndividualData.name3 || ""}`,
          role: primaryData.buyerId === item.id ? 1 : 2
        });
      }

      if (!item.primaryEmail && !item.alternativeEmail) {
        result.push({
          id: item.id,
          number: item.number,
          i: item.id,
          default: true,
          name:
            typeId === 2
              ? customerCompanyData.companyName || ""
              : `${customerIndividualData.name1 || ""} ${
                  customerIndividualData.name2 || ""
                } ${customerIndividualData.name3 || ""}`,
          role: primaryData.buyerId === item.id ? 1 : 2
        });
      }
    }

    return result;
  }, [data, primaryData]);

  const fetchData = useCallback(() => {
    primaryData &&
      Promise.all([CustomersService.get(primaryData.buyerId), CustomersService.get(primaryData.sellerId)])
        .then((res) => {
          setData(res);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
  }, [primaryData, setIsLoading]);

  useEffect(() => fetchData(), [fetchData]);

  return { formattedData };
};
